import Mock from "../mock";

const database = {
  information: {
    name: 'Roberto López',
    aboutContent: "I'm a mobile developer. I can provide clean code and pixel perfect design. I can also work on websites.",
    age: 25,
    phone: '+529511280990',
    nationality: 'Mexican',
    language: 'Spanish',
    email: 'me@robbertuxx.dev',
    address: 'Oaxaca de Juarez, Oaxaca, México',
    freelanceStatus: 'Available',
    socialLinks: {
      facebook: 'https://www.facebook.com/RobberTuxx',
      twitter: 'https://twitter.com/RobberTuxx',
      linkedin: 'https://www.linkedin.com/in/robbertuxx',
      github: 'https://github.com/RobberTuxx',
      medium: 'https://robbertuxx.medium.com',
      wallet: 'https://opensea.io/Robbertuxx'
    },
    brandImage: '/images/brand-image.png',
    aboutImage: '/images/about-image.png',
    aboutImageLg: '/images/about-image-lg.png',
    cvfile: '/files/personal.pdf'
  },
  services: [
    {
      title: "Teacher",
      icon: 'graduation',
      details: "I teach courses for mobile development (React Native)."
    },
    {
      title: "Web Development",
      icon: 'code',
      details: "Development of websites, for different areas from landing page to Saas."
    },
    {
      title: "Mobile Application",
      icon: 'mobile',
      details: "Development of applications with the latest features for Android and iOS platforms."
    }
  ],
  reviews: [
    // {
    //   id: 1,
    //   content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam, aliquid maxime tempora.",
    //   author: {
    //     name: 'Burdette Turner',
    //     designation: 'Web Developer, Abc Company'
    //   }
    // },
    // {
    //   id: 2,
    //   content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
    //   author: {
    //     name: 'Susan Yost',
    //     designation: 'Client'
    //   }
    // },
    // {
    //   id: 3,
    //   content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
    //   author: {
    //     name: 'Irving Feeney',
    //     designation: 'Fiverr Client'
    //   }
    // }
  ],
  skills: [
    {
      title: "React Native",
      value: 80
    },
    {
      title: "ReactJS",
      value: 70
    },
    {
      title: "Typescript",
      value: 75
    },
    {
      title: "NodeJS",
      value: 80
    },
    {
      title: "PostgresSQL",
      value: 70
    },
    {
      title: "Elastic Search",
      value: 60
    }
  ],
  portfolios: [
    {
      id: 1,
      title: "Switch",
      subtitle: "Cost Sharing Application.",
      imageUrl: "/images/switch.jpg",
      largeImageUrl: ["/images/switch-lg.jpg"],
      url: ''
    },
    {
      id: 2,
      title: "Caribe Tours",
      subtitle: "Bus tickets in Dominican Republic.",
      imageUrl: "/images/caribetours.jpg",
      largeImageUrl: [
        "/images/caribetours-lg.jpg",
      ],
      url: ''
    },
    {
      id: 3,
      title: "Caribe Packs",
      subtitle: "Package delivery.",
      imageUrl: "/images/caribepacks.jpg",
      largeImageUrl: [
        "/images/caribepacks-lg.jpg",
      ],
      url: ''
    },
    {
      id: 4,
      title: "PT App",
      subtitle: "Politics.",
      imageUrl: "/images/pt.jpg",
      largeImageUrl: ["/images/pt-lg.jpg"],
      url: ''
    },
    {
      id: 5,
      title: "Encuestas",
      subtitle: "Survey application",
      imageUrl: "/images/encuestas.jpg",
      largeImageUrl: ["/images/encuestas-lg.jpg"]
    },
    {
      id: 6,
      title: "Sumanos Invoices",
      subtitle: "Ticket manager web.",
      imageUrl: "/images/sumanoweb.jpg",
      largeImageUrl: ["/images/sumanoweb-lg.jpg"]
    },
    {
      id: 7,
      title: "Sumanos App",
      subtitle: "Ticket manager app.",
      imageUrl: "/images/sumanoapp.jpg",
      largeImageUrl: ["/images/sumanoapp-lg.jpg"],
      url: ''
    },
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "November 2018 - Present",
        position: "MOBILE APPLICATION DEVELOPER",
        company: "KING TIDE",
        details: "Development of mobile applications with React Native, my main project, an app to divide the expenses of fraternities in the USA, including micropayments and chat"
      },
      {
        id: 2,
        year: "MARCH 2020 - NOVEMBER 2020",
        position: "Mobile Developer",
        company: "Karimnot",
        details: "Development of mobile applications with React native, among which stand out, offline applications, for sales en route and surveys, as well as an application and messaging api through WhatsApp api"
      },
      {
        id: 3,
        year: "OCTOBER 2019 - JUNE 2020",
        position: "Mobile Developer",
        company: "ANTON AGENCY",
        details: "Development of mobile applications with React Native, backend development for the pitafoo platform with node js, typescript and Graphql, connection of Gatsby js static page with backend node js through Apollo"
      },
      {
        id: 4,
        year: "MARCH 2019 - DECEMBER 2019",
        position: "Developer",
        company: "KORE TECNOLOGIA",
        details: "Development of micro services with the golang language, for a custom ERP where I was involved in the billing modules, collaborators, products, I also developed front-end modules with angular js, improvement of the search engine with elastic search. In database use Postgresql and MongoDB."
      }
    ],
    educationExperience: [
      {
        id: 1,
        year: "JULY 2014 - JUNE 2019",
        graduation: "Systems Engineer",
        university: "INSTITUTO TECNOLOGICO DE OAXACA",
        details: ""
      },
      {
        id: 2,
        year: "JULY 2011 - JUNE 2014",
        graduation: "Programming technician",
        university: "CBTIS 265",
        details: ""
      },
    ]
  },
  blogs: [
    {
      id: 1,
      title: 'Markdown & Html supported blog.',
      featuredImage: '/images/blog-image-1.jpg',
      filesource: '../../blog/markdown-html-supported-blog.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 2,
      title: 'Installing NodeJS on your device.',
      featuredImage: '/images/blog-image-2.jpg',
      filesource: '../../blog/installing-nodejs-on-your-device.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 3,
      title: 'UI/UX design starter with Adobe XD.',
      featuredImage: '/images/blog-image-3.jpg',
      filesource: '../../blog/uiux-design-starter-with-adobe-xd.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 4,
      title: 'Boost your post for increasing sales.',
      featuredImage: '/images/blog-image-4.jpg',
      filesource: '../../blog/boost-your-post-for-increasing-sales.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 5,
      title: 'Difference between GatsbyJS & NextJS.',
      featuredImage: '/images/blog-image-5.jpg',
      filesource: '../../blog/difference-between-gatsbyjs-and-nextjs.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 6,
      title: 'How to choose javascript framework for project.',
      featuredImage: '/images/blog-image-6.jpg',
      filesource: '../../blog/how-to-choose-javascript-framework-for-project.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 7,
      title: 'Web automation with python language.',
      featuredImage: '/images/blog-image-7.jpg',
      filesource: '../../blog/web-automation-with-python-language.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 8,
      title: 'Time to use latest technology for creating a website.',
      featuredImage: '/images/blog-image-8.jpg',
      filesource: '../../blog/time-to-use-latest-technology-for-creating-a-website.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 9,
      title: 'Think out of the box.',
      featuredImage: '/images/blog-image-9.jpg',
      filesource: '../../blog/think-out-of-the-box.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 10,
      title: 'Trending designs in 2020.',
      featuredImage: '/images/blog-image-1.jpg',
      filesource: '../../blog/trending-designs-in-2020.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 11,
      title: 'How to get 10k instagram followers?',
      featuredImage: '/images/blog-image-2.jpg',
      filesource: '../../blog/how-to-get-10k-instagram-followers.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 12,
      title: 'What NodeJS can do?',
      featuredImage: '/images/blog-image-3.jpg',
      filesource: '../../blog/what-nodejs-can-do.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 13,
      title: 'Futures of javascript.',
      featuredImage: '/images/blog-image-4.jpg',
      filesource: '../../blog/future-of-javascript.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 14,
      title: 'Popular javascript library in 2020.',
      featuredImage: '/images/blog-image-5.jpg',
      filesource: '../../blog/popular-javascript-library-in-2020.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 15,
      title: 'Promrammers must read books.',
      featuredImage: '/images/blog-image-6.jpg',
      filesource: '../../blog/programmers-must-read-books.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    }
  ],
  contactInfo: {
    phoneNumbers: ['+529511280990'],
    emailAddress: ['me@robbertuxx.dev'],
    address: "Oaxaca de Juarez, Oaxaca, México"
  }
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply(config => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply(config => {
  const response = database.contactInfo;
  return [200, response];
});
